import { Box, Button, Typography } from '@mui/material';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLaunchedScriptsRequest } from 'redux/reducers/errorCorrections/reducer';
import {
	getLaunchedScripts,
	getLaunchedScriptsLoader,
} from 'redux/reducers/errorCorrections/selectors';
import { TPageResponse } from 'redux/types';
import { EasCard } from 'ui/EasCard';
import { EasTableWithoutFilter } from 'ui/EasTableWithoutFilter';
import { THandleAction } from 'ui/EasTable/types';
import { tableStructure } from './tableStructure';
import { TErrorCorrectionProps, TLaunchedScriptRow } from './types';
import { LaunchCorrectionScript } from './LaunchCorrectionScript';

export const ErrorCorrection: FC<TErrorCorrectionProps> = ({ orderId }) => {
	const dispatch = useDispatch();
	const launchedScripts = useSelector(getLaunchedScripts);
	const launchedScriptsLoader = useSelector(getLaunchedScriptsLoader);

	useEffect(() => {
		dispatch(getLaunchedScriptsRequest({ orderId }));
	}, [dispatch, orderId]);

	const tableData = useMemo<TPageResponse<TLaunchedScriptRow>>(
		() => ({
			data: launchedScripts ?? [],
			pageNumber: 1,
			pageSize: launchedScripts?.length ?? 0,
			totalCount: launchedScripts?.length ?? 0,
		}),
		[launchedScripts],
	);

	const handleAction = useCallback<THandleAction>(() => {
		// No row actions are needed for launched scripts.
	}, []);

	const [openScriptDialog, setOpenScriptDialog] = useState(false);
	const handleOpenScriptDialog = () => {
		setOpenScriptDialog(true);
	};

	const handleCloseScriptDialog = () => {
		setOpenScriptDialog(false);
	};

	return (
		<>
			<EasTableWithoutFilter<TLaunchedScriptRow>
				tableStructure={tableStructure}
				items={tableData}
				itemsIsLoading={launchedScriptsLoader}
				handleAction={handleAction}
				skeletonRows={[1]}
			>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography variant="body1" color="primary" fontWeight="bold">
						Order Modifications
					</Typography>
					<Button variant="contained" color="primary" size="small" onClick={handleOpenScriptDialog}>
						Launch Correction Script
					</Button>
				</Box>
			</EasTableWithoutFilter>
			<LaunchCorrectionScript open={openScriptDialog} setClose={handleCloseScriptDialog} />
		</>
	);
};
